@if (description$ | async; as description) {
  <div class="type" [ngStyle]="{ 'background-color': color$ | async }">
    {{ description }}
  </div>
}
